import { contactPath } from 'helper/recordPaths';
import { Navigate, useLocation, useParams } from 'react-router-dom';

// /company/:companyId/contacts/:contactId, /group/:groupId/contacts/:contactId
// and /company/group/:groupId/contacts/:contactId → /contact/:contactId: the
// former addresses of a contact's page, kept for the links already shared;
// the query (?onglet=…) follows.
const LegacyContactRedirect = () => {
  const { contactId } = useParams();
  const { search } = useLocation();
  return <Navigate to={`${contactPath(contactId)}${search}`} replace />;
};

export default LegacyContactRedirect;
